// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-width {
  width: 105px;
}

.commentTextLabel {
  padding-bottom: 215px;
}

.primary {
  margin-left: 5px;
}

.secondary {
  margin-left: 5px;
}

.link {
  color: #055C8D;
  cursor: pointer;
}

.link:hover {
  color: #055C8D;
  cursor: pointer;
}

.appAlert {
  width: 80%;
  position: fixed;
  left: 50%;
  margin-left: -37.5%;
  z-index: 9000;
  text-align: center;
}

.toolbar-header {
  height: 41px;
  font-family: Inter !important;
  width: 100%;
}

.toolbar-spacer {
  padding-left: 18px;
  font-size: 17px;
  color: var(--theme-main-color, #055C8D);
}

.main-content {
  background-color: #f3f3f3;
}

mat-sidenav {
  width: 15%;
  background-color: var(--theme-main-background-color, #055C8D);
  color: white;
  min-width: 160px;
}

mat-sidenav-content {
  overflow-y: hidden;
}

.user-area {
  display: flex;
  bottom: 1%;
  width: 100%;
}

a span {
  vertical-align: middle;
}

.menu-items {
  height: 100% !important;
}

.icon-text {
  margin-top: 5px;
}

.menu-item-text {
  color: #fff;
  font-size: 16px;
  flex-shrink: 1;
  align-self: center;
}

a:hover {
  color: rgba(243, 243, 243, 0.8823529412);
}

.menu-header-item-icon {
  color: #fff;
  font-size: 16px;
  font-family: Inter !important;
  align-self: center;
  vertical-align: middle;
  font-weight: bold;
}

.accordian-button-text {
  color: #fff !important;
  font-size: 18px !important;
  font-weight: normal !important;
  height: -moz-fit-content;
  height: fit-content;
  min-height: 24px;
  text-decoration: none !important;
}

.organisation-suspended::after {
  content: " (suspended)";
}

.card-header {
  padding-left: 5px !important;
  padding-right: 5px !important;
}

.card-body {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  padding-right: 0 !important;
  padding-left: 5px !important;
  position: relative;
}

.menu-header-item-text {
  color: #dedcdc;
  font-size: 17px;
  font-family: Inter !important;
  align-self: center;
  vertical-align: middle;
  font-weight: bold;
  margin-left: 10px;
}

.icon-gap {
  margin-left: 10px;
  display: flex;
  height: 100%;
  min-height: 0;
  align-self: baseline;
}

.vertical-align {
  margin-bottom: auto;
  margin-top: auto;
}

.header-row {
  border-bottom: 1px solid rgb(236, 236, 236);
  align-content: center;
  padding-left: 10px;
  flex-basis: 64px;
  min-height: 64px;
}

.add-organisation-row {
  border-top: 1px solid rgb(236, 236, 236);
  padding-right: 5px;
  flex-basis: 32px;
  min-height: 32px;
}

.logout-row {
  border-top: 1px solid rgb(236, 236, 236);
  justify-content: left;
  padding-left: 5px;
  padding-right: 5px;
  flex-basis: 40px;
  min-height: 40px;
}

.apply-org-row {
  border-top: 1px solid rgb(236, 236, 236);
  justify-content: center;
  padding-left: 5px;
  padding-right: 5px;
}

.menu-row {
  flex-shrink: 1;
  flex-grow: 1;
  padding-left: 5px;
  padding-right: 5px;
}

.add-organisation-link {
  text-align: center;
  color: white;
  cursor: pointer;
}

.add-organisation-link-text {
  text-align: center;
  color: white;
  cursor: pointer;
  margin-left: 10px;
}

.logout-link {
  text-decoration: none;
  background-color: #fff;
  border-radius: 5px;
  border: 1px solid var(--theme-main-border-color, #055C8D);
  margin-top: 5px;
  margin-bottom: 5px;
  padding-left: 1.5vw;
  padding-right: 1.5vw;
  padding-top: 3px;
  padding-bottom: 4px;
  text-align: center;
  font-family: Inter;
  font-size: 13px;
  font-weight: 600;
  color: var(--theme-main-color, #055C8D);
  cursor: pointer;
}

.logout-link:hover {
  text-decoration: none;
  background-color: var(--theme-main-background-color, #055C8D);
  border-radius: 5px;
  border: 1px solid #fff;
  margin-top: 5px;
  margin-bottom: 5px;
  padding-left: 1.5vw;
  padding-right: 1.5vw;
  padding-top: 3px;
  padding-bottom: 4px;
  text-align: center;
  font-family: Inter;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
}

.content-panel {
  overflow-y: auto;
  min-height: 0;
}

.settings-icon {
  color: white;
}

.las {
  font-size: 17px;
}

.organisation-modules-settings {
  height: 93%;
  overflow-x: hidden;
  overflow-y: scroll;
}

.menu-item {
  padding-left: 28px;
}

.organisation-line {
  color: white;
  background-color: white;
  width: 100%;
}

.bottom-group {
  position: absolute;
  bottom: 4%;
  width: 229.63px;
}

.bottom-group-line {
  background-color: white;
  width: 100%;
}

.link-spacer {
  margin-top: 1%;
  margin-bottom: 1%;
}

.row-item {
  padding-top: 15px;
  padding-bottom: 15px;
}

.padded-menu-item {
  padding-left: 5%;
  padding-top: 2px;
  padding-bottom: 2px;
}

.icon {
  color: white;
  float: right;
}

.menu-item-module {
  padding-left: 40px;
}

.tool-map {
  bottom: 1%;
  position: absolute;
  width: 100%;
}

.keyboard-backspace {
  vertical-align: top;
  color: white;
}

.organisation-setting-icon {
  display: none;
  width: 10%;
}

.organisation-setting-label {
  font-weight: bold;
  padding-right: 0;
  padding-left: 0;
}

.user-organisations {
  overflow-y: scroll;
  height: 40%;
}

.module-item {
  width: 85%;
  margin-left: 5%;
}

.icon-button {
  padding: 0;
  min-width: 0;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  line-height: 20px;
  color: white;
  border-style: none;
  border-color: var(--theme-main-border-color, #055C8D);
}

.icon-header-button {
  cursor: pointer;
  font-size: 26px;
  vertical-align: middle;
}

.dropdown-content {
  display: block;
  position: absolute; /* new */
  width: 100%; /* new */
}

.module-item-icon-column {
  flex-basis: 24px;
  min-width: 24px;
  max-width: 24px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.module-item-column {
  flex-shrink: 1;
  flex-grow: 1;
  padding-left: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  cursor: pointer;
}

.add-org {
  padding-left: 5px;
}

.module-suspended::after {
  content: " (suspended)";
}

.border-bottom {
  border-bottom: 5px solid red;
}

.municipalityheader {
  font-size: 18px;
  font-weight: 500;
}

.float-right {
  float: right !important;
}

.files-list {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 6px;
  background: #ffffff;
  border: 1px dashed;
  border-radius: 12px;
  color: var(--theme-main-color, #055C8D);
}

.files-list .delete-file {
  background: transparent;
  border: none;
  cursor: pointer;
}

.files-list .delete-file img {
  width: 30px;
}

.la-trash-alt {
  color: red;
}

.overlay {
  height: 100vh;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.286);
  z-index: 9000;
  top: 0;
  left: 0;
  position: fixed;
}

.center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}

.uploader-status ::ng-deep .mat-mdc-progress-spinner circle, .mat-mdc-progress-spinner circle {
  stroke: var(--theme-main-color, #055C8D);
}

.record-select {
  width: 100px;
  height: 30px;
}

.vertical-align {
  display: flex;
  align-items: center;
}

.checkbox-column {
  text-align: center;
  width: 45px;
  padding-right: 0;
}

.custom-table {
  height: 100%;
  overflow-y: scroll !important;
  overflow-x: hidden !important;
}

.export-row {
  flex-basis: 40px;
  min-height: 40px;
  margin-top: 5px;
  margin-bottom: 10px;
}

.content-panel {
  overflow-y: auto;
  overflow-x: auto;
  min-height: 0;
}

thead {
  color: var(--theme-main-color, #055C8D);
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 10.5px;
}

tbody {
  overflow-y: auto !important;
  background-color: #FFFFFF;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 11.4px;
  color: #859296;
}

.tbody-export {
  max-height: calc(100vh - 50px) !important;
}

th {
  position: sticky;
}

.table thead th {
  border-top: none;
  position: sticky;
  top: 0;
  background: #F3F3F3;
  z-index: 1;
  vertical-align: middle !important;
}

th.desc:after {
  transform: rotate(180deg);
  -ms-transform: rotate(180deg);
}

th.desc:after, th.asc:after {
  content: url("data:image/svg+xml; utf8, <svg width='11' height='9' viewBox='0 0 9 10' fill='none' xmlns='http://www.w3.org/2000/svg'> <g> <path d='M3.76708 0.531373V8.20932' stroke='%2302B9F1'/> <path d='M0.541931 6.7587L3.76706 8.94208L6.68283 6.7587' stroke='%2302B9F1'/> </g> </svg>");
  width: -moz-fit-content;
  width: fit-content;
  margin-left: 5px;
  height: 13px;
  display: inline-block;
  vertical-align: text-bottom;
}

.table td, .table th {
  vertical-align: top !important;
  padding: 0.5rem 0.4rem;
}

table {
  display: flex;
  flex-flow: column;
  height: 100%;
  width: 100%;
}

table thead {
  /* head takes the height it requires,
  and it's not scaled when table is resized */
  flex: 0 0 auto;
  width: calc(100% - 0.9em);
}

table tbody {
  /* body takes all the remaining available space */
  border-top: 2px solid var(--theme-main-border-color, #055C8D);
  flex: 1 1 auto;
  display: block;
  overflow-y: scroll;
}

table tbody tr {
  width: 100%;
}

table thead, table tbody tr {
  display: table;
  table-layout: fixed;
}

.table-link {
  color: var(--theme-main-color, #055C8D);
  cursor: pointer;
}

.table-link:hover {
  text-decoration: underline;
}

td {
  word-wrap: break-word;
  white-space: pre-line;
}

.filter {
  height: auto;
  min-width: -moz-fit-content;
  min-width: fit-content;
}

input[type=radio], input[type=checkbox] {
  z-index: 1;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #859296;
  background-color: var(--theme-main-background-color, #055C8D);
}

.selectable-row {
  cursor: pointer;
}

.radio-button-column {
  width: 48px !important;
}

.recipient-type-labels-padding {
  padding-top: 5px;
}

.recipient-type-radio-btn-margins {
  margin-left: 8px;
}

.footer {
  margin-top: 3px;
  flex-direction: row;
  justify-content: flex-end;
  height: 52px;
  padding: 9px 5px 2px 5px;
  position: fixed;
  bottom: 0px;
}

.filename-text {
  width: 250px;
  padding: 5px;
  margin-right: 10px;
}

.workflow-form-label {
  padding-right: 5px;
  color: var(--theme-main-color, #055C8D);
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.305883px;
  white-space: nowrap;
}

.expand-table a:hover {
  text-decoration: none;
  color: inherit;
}
.expand-table table {
  overflow-x: auto;
  max-width: 62vw;
  position: sticky;
  top: 0;
  bottom: 0;
  overflow-y: auto;
}
.expand-table thead {
  position: sticky;
  top: 0;
}
.expand-table th {
  width: 115px;
  min-width: 91px;
  position: sticky;
  top: 0;
}
.expand-table tbody {
  display: table;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
